/**
 * This is the dropdown Datepicker widget
 *
 * optional @prop widgetId {String} widget ID
 * optional @prop type {String} Type of the widget
 *                valid types are small or medium
 * optional @prop color {string} Color of the widget
 *                valid colors are gray (white is the default)
 * optional @prop selectedValue {Object}
 *                selectedValue.date {Date} Date format of the selected value
 *                selectedValue.value {String} Formatted value of the selected value
 * optional @prop onSelectedValue {Func} what to do when a user selects a date
 * optional @prop placeholder {String} Placeholder text
 * optional @prop datepickerOptions {Object} Preset options for the Datepicker widget
 *
 * return widgetID: {String} widget ID
 *        selectedDate: {Date} selected date
 */
import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import DropdownBase from './DropdownBase';
import Datepicker from '../Datepicker';
import ArrowUpIcon from '../../Icons/ArrowUpIcon';
import ArrowDownIcon from '../../Icons/ArrowDownIcon';

import styles from './Dropdowns.scss';

export default class DropdownDatepicker extends DropdownBase {
    static displayName = displayName('Widgets/Dropdowns/DropdownDatepicker');

    static propTypes = {
        datepickerOptions: PropTypes.object,
        placeholder: PropTypes.string,
    };

    static defaultProps = {
        datepickerOptions: {},
        placeholder: '',
    };

    constructor(props) {
        super(props);

        this.openDropdownMenu = this.openDropdownMenu.bind(this);
    }

    onDateClick = (selectedDate) => {
        this.closeDropdownMenu();
        this.props.onSelectedValue(this.props.widgetId, selectedDate);
    };

    getInputValue() {
        const selectedValue = this.props.selectedValue.value;
        let inputValue;

        if (selectedValue.length) {
            inputValue = selectedValue;
        } else {
            inputValue = this.props.placeholder;
        }

        return inputValue;
    }

    render() {
        const { selectedValue } = this.props;

        return (
            <div
                ref={(c) => { this.datepickerWidget = c; }}
                {...this.getWidgetProps()}
                data-field={`dropdown-datepicker-${this.props.widgetId}`}
            >
                <data
                    role="presentation"
                    onClick={this.openDropdownMenu}
                    data-action="toggle-dropdown"
                >
                    <span
                        ref={(c) => { this.dropdownInput = c; }}
                        className={styles[this.getInputClass(selectedValue.value)]}
                        disabled
                    >
                        {this.getInputValue()}
                    </span>

                    {this.state.isDropdownEnabled
                        ? <ArrowUpIcon className={styles['dropdown-icon']} />
                        : <ArrowDownIcon className={styles['dropdown-icon']} />
                    }
                </data>

                {
                    this.state.isDropdownEnabled &&
                    <Datepicker
                        {...this.props.datepickerOptions}
                        selectedDate={selectedValue.date}
                        className={styles['datepicker-module']}
                        onSelectDate={this.onDateClick}
                    />
                }
            </div>
        );
    }
}
